module.exports = __webpack_public_path__ + "81c240c8e237f38493866014a58feda9.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-intuit.png
// module id = 634
// module chunks = 0